export default __webpack_public_path__ + "static/media/supp_installation.c2eae072.jpg";